import { render, staticRenderFns } from "./DraftProduct.vue?vue&type=template&id=b5174486&scoped=true&"
import script from "./DraftProduct.vue?vue&type=script&lang=js&"
export * from "./DraftProduct.vue?vue&type=script&lang=js&"
import style0 from "./DraftProduct.vue?vue&type=style&index=0&id=b5174486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5174486",
  null
  
)

export default component.exports